/* eslint-disable @typescript-eslint/no-namespace */
export namespace UnderwriterAction {
  /**
   * Action to fetch underwriter summary from Products Service
   */
  export class LoadSummary {
    public static readonly type = '[Underwriter] Fetch Underwriter Data (API)';
  }

  /**
   * Action to fetch tender types for each insurance contract id
   */
  export class LoadTenderTypes {
    public static readonly type = '[Underwriter] Fetch tender types (API)';
    constructor(public contractId: number) {}
  }

  export class SetCurrentContractId {
    public static readonly type = '[Ui Context] Set Current Contract Id';
    constructor(public planId: number) {}
  }
}
